export default __webpack_public_path__ + "static/media/h.2804844e.gif";